import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../utils/supabase';
import { useOptionalAdminAnalyticsHierarchy } from '../../contexts/AdminAnalyticsHierarchyContext';
import AdminAnalyticsSidebarNav from './AdminAnalyticsSidebarNav';

function AdminSidebar({ mobileOpen, onCloseMobile }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isAnalytics = location.pathname.startsWith('/admin/analytics');
  const showAnalyticsControl = isAnalytics || (
    location.pathname.startsWith('/bootcamp/') && !!searchParams.get('client')
  );
  const analyticsHierarchy = useOptionalAdminAnalyticsHierarchy();

  const handleLogout = async () => {
    try { await supabase.auth.signOut(); } catch {}
    navigate('/login', { replace: true });
  };

  const navClass = ({ isActive }) =>
    `dashboard-nav-item${isActive ? ' dashboard-nav-item-active' : ''}`;

  const path = location.pathname;
  const clientsActive = (() => {
    if (path.startsWith('/client/') && path.endsWith('/view')) return false;
    return path.startsWith('/admin/clients')
      || path.startsWith('/client/')
      || path.startsWith('/region/')
      || /^\/team\/[^/]+\/(edit-members|bootcamps)$/.test(path);
  })();
  const coursesActive = path.startsWith('/admin/courses')
    || path.startsWith('/course/')
    || path.startsWith('/archived-courses');

  return (
    <aside className={`dashboard-sidebar${showAnalyticsControl ? ' dashboard-sidebar-with-analytics' : ''}${mobileOpen ? ' dashboard-sidebar-open' : ''}`}>
      <div className="dashboard-sidebar-header">
        <div className="dashboard-brand">Propelion</div>
        <div className="dashboard-brand-sub">Admin</div>
      </div>

      <nav className="dashboard-nav">
        <NavLink
          to="/admin/clients"
          className={`dashboard-nav-item${clientsActive ? ' dashboard-nav-item-active' : ''}`}
          onClick={onCloseMobile}
        >
          Clients
        </NavLink>
        <NavLink
          to="/admin/courses"
          className={`dashboard-nav-item${coursesActive ? ' dashboard-nav-item-active' : ''}`}
          onClick={onCloseMobile}
        >
          Courses
        </NavLink>
        <NavLink to="/admin/bootcamps" className={navClass} onClick={onCloseMobile}>
          Bootcamps
        </NavLink>
        <NavLink
          to="/admin/analytics"
          className={navClass}
          onClick={(e) => {
            onCloseMobile?.();
            if (isAnalytics && analyticsHierarchy) {
              e.preventDefault();
              analyticsHierarchy.setClient('');
            }
          }}
        >
          Analytics
        </NavLink>
        {showAnalyticsControl && <AdminAnalyticsSidebarNav />}
      </nav>

      <div className="dashboard-sidebar-footer">
        <NavLink to="/propelion-ai" className="dashboard-nav-link-secondary" onClick={onCloseMobile}>
          Propelion AI
        </NavLink>
        <button type="button" className="dashboard-footer-btn dashboard-footer-btn-muted" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
